import './index.css';

export const Loader = ({ isAuthLoader }: { isAuthLoader?: boolean }) => {
  const LoadingAnimation = () => {
    return (
      <div className="loader loader4">
        <div>
          <div>
            <div>
              <div>
                <div>
                  <div>
                    <div>
                      <div>
                        <div>
                          <div></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return isAuthLoader ? (
    <div className="authLoader">
      <LoadingAnimation />
      <div>Loading user session...</div>
    </div>
  ) : (
    <LoadingAnimation />
  );
};
